import intl from 'react-intl-universal'
import IconGarage from 'components/icons/icn-garage.icon'
import IconBrewery from 'components/icons/icn-fabrica-blue-semi-light.icon'

const chartDataDefault = {
  Details: [],
  guides: {},
}

export const types = {
  brewery: 1,
  supplierUnit: 2,
  externalWarehouse: 3
}

export const mountChartData = (_chartData) => {
  if (!_chartData) {
    _chartData = chartDataDefault
  }
  return ({
    ..._chartData,
    guides: {
      Over: _chartData ? _chartData.Over : 0,
      Out: _chartData ? _chartData.Out : 0,
    }
  })
}

export const isExternalWarehouse = (unitType) => unitType === types.externalWarehouse
export const isBrewery = (unitType) => unitType === types.brewery
export const getLabelTitle = (unitType) => isExternalWarehouse(unitType) ?
  intl.get('commons.brewery') :
  intl.get('stocks.stockDetail.externalWarehouse')

export const getButtonSVG = (unitType) => isExternalWarehouse(unitType) ?
<IconBrewery height={'auto'} width={'auto'}/> : <IconGarage height={'auto'} width={'auto'}/>